import React, { Component } from "react";
import "../../../assets/scss/cardTemplate.scss";
import download from "../../../assets/images/cardTemplates/download.png";
import schoolLogo from "../../../assets/images/logo/logo2.png";
import signature from "../../../assets/images/cardTemplates/signature.PNG";
import { URL } from "../../../utils/Constants";

class Template1 extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div
        className={
          this.props?.mode === "create"
            ? `cardTemplateContainer`
            : `template1Container cardTemplateContainer`
        }
      >
        <div data-id={this.props.id} className="front">
          <div className="top">
            <img
              className={
                this.props?.mode === "create" ? `createImg` : `listImg`
              }
              src={this.props.userImage ? this.props.userImage : download}
            />
          </div>
          <div className="bottom">
            <div
              style={{ top: this.props?.mode === "create" ? "54px" : "30px" }}
              className="person-details"
            >
              <p
                style={{ margin: 0 }}
                className={this.props?.mode === "create" ? `` : `temp1BtmPara`}
              >
                {this.props.studentName
                  ? this.props.studentName
                  : "People Name"}
              </p>
              <p
                style={{ margin: 0 }}
                className={
                  this.props?.mode === "create" ? `desi` : `desi temp1BtmPara `
                }
              >
                {this.props.subtitle
                  ? this.props.subtitle
                  : "Class - Section / Designation"}
              </p>
              {(this.props.rollNumber || this.props?.mode === "create") && (
                <p
                  style={{ margin: 0 }}
                  className={
                    this.props?.mode === "create"
                      ? `desi`
                      : `desi temp1BtmPara `
                  }
                >
                  Roll No.:{" "}
                  {this.props.rollNumber
                    ? this.props.rollNumber
                    : "Roll Number"}
                </p>
              )}
              {(this.props.dateOfBirth || this.props?.mode === "create") && (
                <p
                  style={{ margin: 0 }}
                  className={
                    this.props?.mode === "create"
                      ? `desi`
                      : `desi temp1BtmPara `
                  }
                >
                  DOB:{" "}
                  {this.props.dateOfBirth
                    ? this.props.dateOfBirth
                    : "Date Of Birth"}
                </p>
              )}
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <div className="schoolInfo">
                <div className="barcode">
                  <img
                    src={
                      this.props.schoolLogo ? this.props.schoolLogo : schoolLogo
                    }
                  />
                </div>
                <p
                  style={{ textAlign: "center" }}
                  className="no schoolCardName"
                >
                  {this.props.schoolName
                    ? this.props.schoolName
                    : "School Name"}
                </p>
                <p
                  style={{ textAlign: "center" }}
                  className="no schoolCardAddress"
                >
                  {this.props.schoolAddress
                    ? this.props.schoolAddress
                    : "School Address"}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div data-id={this.props.id} className="back">
          <div className="details-info">
            <p>
              <b>Emergency Contact: </b>
            </p>
            <p>
              {this.props?.emergencyContact?.name &&
                this.props?.emergencyContact?.name}
            </p>
            <p>
              {!this.props?.emergencyContact?.name &&
                (!this.props?.emergencyContact?.contactNumber ||
                  !this.props?.emergencyContact?.mobileNumber) &&
                "-"}
            </p>
            <p>
              {(this.props?.emergencyContact?.contactNumber ||
                this.props?.emergencyContact?.mobileNumber) &&
                (this.props?.emergencyContact?.contactNumber ||
                  this.props?.emergencyContact?.mobileNumber)}
            </p>
            <div className="signatureBox">
              <div
                className={
                  this.props?.mode === "create"
                    ? "signatureDiv"
                    : "signatureDiv signatureDivtemp1"
                }
              >
                <img
                  alt="signature"
                  src={this.props.signature ? this.props.signature : signature}
                />
              </div>
              <p>_______________________</p>
              {/* <div className="idSignature idSignatureHolder">
                <img
                  src={
                    this.props?.authorizedSignature
                      ? this.props?.authorizedSignature
                      : "Authorized Signature"
                  }
                />
              </div> */}
              <p className="text-center">
                {this.props.authorizedSignatureName || "Sample signature Name"}
              </p>
            </div>
          </div>
          <div className="schoolData">
            <p className="validDateCss">
              <strong>Issued Date: </strong>{" "}
              {this.props.issuedDate ? this.props.issuedDate : "Date"}
            </p>
            <p className="validDateCss mb-1">
              <strong>Valid Until: </strong>{" "}
              {this.props.validityDate ? this.props.validityDate : "Date"}
            </p>
            <div className="barcode">
              <img
                className="barcodeBackImg"
                src={this.props.schoolLogo ? this.props.schoolLogo : schoolLogo}
              />
            </div>
            <div style={{ display: "inline-block" }}>
              {this.props.schoolWebAddress && (
                <small
                  className="webAddress"
                  style={{
                    display: "inline-block",
                    marginBottom: "4px",
                    marginTop: "16px",
                  }}
                >
                  {this.props.schoolWebAddress}
                </small>
              )}
              <small
                className="webAddress"
                style={{ display: "inline-block", margin: "0" }}
              >
                {this.props.schoolContact
                  ? this.props.schoolContact
                  : "Tel: Contact Number"}
              </small>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Template1;
